import React from "react";
import Sidebar from "./Sidebar";
import {Box, CssBaseline} from "@mui/material";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import SendSpam from "./content/bulkmail/SendSpam";
import EmailListSmart from "./content/emailList/EmailListSmart";
import EmailLogs from "./content/EmailLogs";
import SettingsPage from "./content/settings/SettingsPage";
import AddTemplate from "./content/templates/templates/AddTemplate";
import TemplatesPage from "./content/templates/templates/TemplatesPage";
import EditTemplate from "./content/templates/templates/EditTemplate";
import EditTargetEmailList from "./content/emailList/EditTargetEmailList";

export default function MainPage() {

  return (
    <BrowserRouter>
      <Box sx={{display: "flex"}}>
        <CssBaseline/>
        <Sidebar/>
        <Box component="main" sx={{flexGrow: 1, bgcolor: "background.default", p: 3}}>
          <Routes>
            <Route path="/sendSpam" element={<SendSpam/>}/>
            <Route path="/templates" element={<TemplatesPage/>} />
            <Route path="/templates/:id/edit" element={<EditTemplate/>}/>
            <Route path="/emailList/:id/target" element={<EditTargetEmailList/>}/>
            <Route path="/template" element={<AddTemplate/>}/>
            <Route path="/emailList" element={<EmailListSmart/>}/>
            <Route path="/settings" element={<SettingsPage/>}/>
            <Route path="/logs" element={<EmailLogs/>}/>
            <Route path="*" element={<TemplatesPage/>}/>
          </Routes>
        </Box>
      </Box>
    </BrowserRouter>)
}
